import { BarChartBig, Presentation, ScrollText } from 'lucide-react';

import { useAgentChatContext } from '@/components/agent-chat';
import { Button } from '@/components/ui/button';
import { CapitolMark } from '@/icons/capitol-mark';

const STARTER_PROMPTS = [
  {
    icon: Presentation,
    label: 'Create a presentation',
    draft: 'Create a presentation about ',
  },
  {
    icon: BarChartBig,
    label: 'Automate a task',
    draft: 'Automate a task that ',
  },
  { icon: ScrollText, label: 'Make a skill', draft: 'Make a skill that ' },
];

export function ChatHomeGreeting() {
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-center gap-2'>
        <CapitolMark className='size-7 shrink-0 text-primary' />
        <p className='truncate text-base font-medium text-foreground'>
          Welcome to Capitol AI
        </p>
      </div>
      <h1 className='text-4xl font-light tracking-[-0.03em] text-foreground'>
        How can I help you today?
      </h1>
    </div>
  );
}

export function ChatHomeStarterPrompts() {
  const { isSending, setComposerDraft } = useAgentChatContext();

  return (
    <div className='flex flex-wrap items-center gap-2'>
      {STARTER_PROMPTS.map(({ icon: Icon, label, draft }) => (
        <Button
          key={label}
          variant='secondary'
          size='sm'
          className='h-9 gap-2 rounded-full px-4 text-sm font-medium drop-shadow-sm'
          disabled={isSending}
          onClick={() => setComposerDraft(draft)}
        >
          <Icon className='size-4' />
          {label}
        </Button>
      ))}
    </div>
  );
}
